angular.module("impactx.purchaserequest").service('TemplateNameService', TemplateNameService);

TemplateNameService.inject = ['$mdDialog'];

function TemplateNameService($mdDialog) {
    return {
        showTemplateName: function (items, entryPoint, event) {
            return $mdDialog.show({
                event: event,
                controller: 'TemplateCtrl',
                controllerAs: 'templateCtrl',
                templateUrl: 'modules/status/purchaserequest/templates/savetemplate.html',
                locals: {
                    items: items,//  selectedListItems.getSelectedItems(),
                    entryPoint: entryPoint
                }
            });
        }
    }
}
